// @flow

export const operators = [
  { value: "add", display: "add" },
  { value: "subtract", display: "subtract" }
];
